module.exports = __webpack_public_path__ + "static/aerospace-light-2d2eda297bc17106ac47ad9c277286d9.svg";